import React from "react";

export default () => {
  return (
    <svg
      width="231px"
      height="206px"
      viewBox="0 0 231 206"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Class III</title>
      <defs>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="146.694484%"
          id="c3-linearGradient-1"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <polygon
          id="c3-path-2"
          points="128.000007 4.35999794 154.100008 4.35999794 154.100008 71.9600017 128.000007 71.9600017"
        ></polygon>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="c3-linearGradient-3"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M125.400007,0 L156.700007,0 C158.135947,-2.63777977e-16 159.300007,1.16405971 159.300007,2.60000014 L159.300007,12.8000004 C159.300007,14.2359409 158.135947,15.4000006 156.700007,15.4000006 L125.400007,15.4000006 C123.964067,15.4000006 122.800007,14.2359409 122.800007,12.8000004 L122.800007,2.60000014 C122.800007,1.16405971 123.964067,-1.80311232e-16 125.400007,0 Z"
          id="c3-path-4"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="146.694484%"
          id="c3-linearGradient-5"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M90.350005,1.50000036 L175.350005,85.5000004 L166.400005,85.5000004 L166.400009,182.200005 L14.3000008,182.200005 L14.299005,85.5000004 L5.35000497,85.5000004 L90.350005,1.50000036 Z"
          id="c3-path-6"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="c3-linearGradient-7"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <rect id="c3-path-8" x="0" y="0" width="44" height="44" rx="5"></rect>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="146.694484%"
          id="c3-linearGradient-9"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M15.3534497,0.334949994 C14.9747497,-0.0437499993 14.3581198,-0.0437499993 13.9794198,0.334949994 L10.8184998,3.49726994 L6.40254989,2.80136495 C5.8638649,2.71386495 5.37442491,3.07890445 5.29101991,3.60800994 L4.59238492,8.02395986 L0.61393499,10.0556048 C0.135414998,10.2975983 -0.0532349991,10.8841248 0.190119997,11.3612798 L2.22039996,15.3453297 L0.191484997,19.3293797 C-0.0518734991,19.8065347 0.138165998,20.3916997 0.616664989,20.6336896 L4.60071492,22.6626046 L5.30207991,27.0785545 C5.38684641,27.6076495 5.8790199,27.9672395 6.41360989,27.8851995 L10.8295598,27.1838345 L13.9904798,30.3433895 C14.1777858,30.529327 14.4266148,30.6277645 14.6781598,30.6277645 C14.8053077,30.6277645 14.9297222,30.6031553 15.0500347,30.5539355 C15.4137197,30.403544 15.6488497,30.0494455 15.6488497,29.6570605 L15.6474823,1.48486097 C15.6474823,1.39872948 15.6365448,1.31396298 15.6160372,1.23466698 C15.6857642,0.920212984 15.5968964,0.57978199 15.3535372,0.335061994 L15.3534497,0.334949994 Z M11.8506498,25.4610996 C11.6674458,25.2765306 11.4199748,25.1767246 11.1643348,25.1767246 C11.1151143,25.1767246 11.0631638,25.1808259 11.0112098,25.1890292 L7.06670988,25.8138492 L6.44052489,21.8693492 C6.39130789,21.5630992 6.19853139,21.2965042 5.9223499,21.1570292 L2.36354996,19.3427693 L4.17371493,15.7825693 C4.31453393,15.5063983 4.31453393,15.1796243 4.17234783,14.9007443 L2.36081786,11.3433444 L5.9182178,9.52771944 C6.19575729,9.38690044 6.38714779,9.12164944 6.43502779,8.81403445 L7.05984778,4.87093452 L11.0053977,5.49162451 C11.3171182,5.54221001 11.6247227,5.43830551 11.8421077,5.21955551 L13.7055777,3.35608554 L13.7055777,7.55608547 C9.59867774,7.82405247 6.35277779,11.2296854 6.35277779,15.4009853 C6.35277779,19.5736853 9.59983274,22.9791852 13.7055777,23.2472852 L13.7055777,27.3118351 L11.8506498,25.4610996 Z"
          id="c3-path-10"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="146.694484%"
          id="c3-linearGradient-11"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M32.5457994,14.4304998 L29.1373945,14.4304998 L31.2182495,12.3496448 C31.5969495,11.9695798 31.5969495,11.3557148 31.2182495,10.9756148 C30.8395495,10.5955498 30.2243195,10.5955498 29.8455845,10.9756148 L26.3906996,14.4304998 L20.5159497,14.4318669 L24.7925996,10.1566169 L28.9323995,10.1566169 C29.4697195,10.1566169 29.9030895,9.72048193 29.9030895,9.18456194 C29.9030895,8.64724195 29.4696845,8.21250696 28.9323995,8.21250696 L26.7339795,8.21250696 L28.9624995,5.983987 C29.3425645,5.605287 29.3425645,4.99005702 28.9624995,4.60995702 C28.5837995,4.22989203 27.9699345,4.22989203 27.5898345,4.60995702 L25.3749996,6.82479198 L25.3749996,4.65370702 C25.3749996,4.11778703 24.9415946,3.68165204 24.4043096,3.68165204 C23.8669896,3.68165204 23.4336196,4.11642203 23.4336196,4.65370702 L23.4322525,8.76900695 L19.1433526,13.0579069 L19.1433526,6.86325698 L22.5982375,3.40700704 C22.9783025,3.02694205 22.9783025,2.41307706 22.5982375,2.03434207 C22.2195375,1.65427707 21.6029075,1.65427707 21.2255725,2.03434207 L19.1447176,4.11519703 L19.1433501,1.02945708 C19.1433501,0.492137092 18.7085801,0.057402099 18.1726601,0.057402099 C17.6367401,0.057402099 17.2019702,0.492172092 17.2019702,1.02945708 L17.2019702,29.7774066 C17.2019702,30.3147266 17.6367401,30.7480966 18.1726601,30.7480966 C18.7085801,30.7480966 19.1433501,30.3146916 19.1433501,29.7774066 L19.1433501,26.0492067 L21.2242051,28.1300616 C21.4128761,28.3201011 21.6630701,28.4130681 21.9105201,28.4130681 C22.1593491,28.4130681 22.4081851,28.3200976 22.5982001,28.1300616 C22.9782651,27.7499966 22.9782651,27.1361316 22.5982001,26.7573966 L19.1433151,23.3025117 L19.1433151,17.7476618 L23.4801651,22.0831117 L23.4801651,26.1998117 C23.4801651,26.7371316 23.91357,27.1705016 24.450855,27.1705016 C24.98954,27.1705016 25.42291,26.7370966 25.42291,26.1998117 L25.42291,24.0273617 L27.684225,26.2886767 C27.872896,26.4773476 28.12309,26.5730516 28.37054,26.5730516 C28.620734,26.5730516 28.868205,26.4787161 29.05822,26.2886767 C29.4382849,25.9086117 29.4382849,25.2947467 29.05822,24.9146467 L26.78595,22.6410117 L28.98164,22.6410117 C29.5189599,22.6410117 29.9523299,22.2062417 29.9523299,21.6689567 C29.9523299,21.1330367 29.5189249,20.6969017 28.98164,20.6969017 L24.84184,20.6982692 L20.5161901,16.3750693 L26.39094,16.3750693 L29.8458249,19.8299542 C30.0344959,20.0186252 30.2846899,20.1143292 30.5335049,20.1143292 C30.7809654,20.1143292 31.0298049,20.0186252 31.2184549,19.8299542 C31.5985199,19.4498892 31.5985199,18.8346242 31.2184549,18.4559242 L29.136235,16.3750693 L32.5446399,16.3750693 C33.0805599,16.3750693 33.5153331,15.9402993 33.5153331,15.4030143 C33.5166973,14.8656943 33.0819249,14.4309593 32.5460049,14.4309593 L32.5457994,14.4304998 Z"
          id="c3-path-12"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="c3-linearGradient-13"
        >
          <stop stopColor="#FFFFFF" stopOpacity="0.5" offset="0%"></stop>
          <stop stopColor="#000000" stopOpacity="0.5" offset="100%"></stop>
        </linearGradient>
        <path
          d="M4,182 L175.600009,182 L175.600009,194.600001 C175.600009,196.256855 174.256864,197.600001 172.600009,197.600001 L7,197.600001 C5.34314575,197.600001 4,196.256855 4,194.600001 L4,182 L4,182 Z"
          id="c3-path-14"
        ></path>
        <linearGradient
          x1="50%"
          y1="0%"
          x2="50%"
          y2="100%"
          id="c3-linearGradient-15"
        >
          <stop stopColor="#00AEEF" offset="0%"></stop>
          <stop stopColor="#7ED6F6" offset="100%"></stop>
        </linearGradient>
      </defs>
      <g
        id="c3-Wireframe-v4-Layout-v2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="c3-PWA-Desktop-Page1---Location-Classification---Class-3"
          transform="translate(-842.000000, -488.000000)"
        >
          <g id="c3-Class-IV" transform="translate(318.000000, 379.000000)">
            <g id="c3-Group-3" transform="translate(1.000000, 67.000000)">
              <g id="c3-class-III" transform="translate(531.000000, 50.000000)">
                <g id="c3-Rectangle-Copy-38">
                  <use fill="#8FD5EF" href="#c3-path-2"></use>
                  <use
                    fill="url(#c3-linearGradient-1)"
                    style={{ mixBlendMode: "screen" }}
                    href="#c3-path-2"
                  ></use>
                </g>
                <g id="c3-Rectangle-Copy-39">
                  <use fill="#00AEEF" href="#c3-path-4"></use>
                  <use
                    fill="url(#c3-linearGradient-3)"
                    style={{ mixBlendMode: "screen" }}
                    href="#c3-path-4"
                  ></use>
                </g>
                <g id="c3-Combined-Shape">
                  <use fill="#8FD5EF" href="#c3-path-6"></use>
                  <use
                    fill="url(#c3-linearGradient-5)"
                    style={{ mixBlendMode: "screen" }}
                    href="#c3-path-6"
                  ></use>
                </g>
                <g
                  id="c3-Group-4"
                  transform="translate(179.000000, 154.000000)"
                >
                  <g id="c3-Group-9">
                    <g id="c3-Rectangle">
                      <use fill="#487FB4" href="#c3-path-8"></use>
                      <use
                        fillOpacity="0.5"
                        fill="url(#c3-linearGradient-7)"
                        style={{ mixBlendMode: "multiply" }}
                        href="#c3-path-8"
                      ></use>
                    </g>
                    <g
                      id="c3-np_cool_126179_000000"
                      transform="translate(22.000000, 22.500000) scale(-1, 1) translate(-22.000000, -22.500000) translate(5.000000, 7.000000)"
                    >
                      <g id="c3-Shape">
                        <use fill="#8FD5EF" href="#c3-path-10"></use>
                        <use
                          fill="url(#c3-linearGradient-9)"
                          style={{ mixBlendMode: "screen" }}
                          href="#c3-path-10"
                        ></use>
                      </g>
                      <g id="c3-Path">
                        <use fill="#8FD5EF" href="#c3-path-12"></use>
                        <use
                          fill="url(#c3-linearGradient-11)"
                          style={{ mixBlendMode: "screen" }}
                          href="#c3-path-12"
                        ></use>
                      </g>
                    </g>
                  </g>
                </g>
                <g
                  id="c3-Rectangle-Copy-35"
                  transform="translate(89.800005, 189.800000) scale(1, -1) translate(-89.800005, -189.800000) "
                >
                  <use fill="#00AEEF" href="#c3-path-14"></use>
                  <use
                    fill="url(#c3-linearGradient-13)"
                    style={{ mixBlendMode: "screen" }}
                    href="#c3-path-14"
                  ></use>
                </g>
                <path
                  d="M0.650000036,89.9000052 L89.4307661,1.11923915 C89.9384477,0.611557545 90.7615622,0.611557545 91.2692438,1.11923915 L180.05001,89.9000052 L180.05001,89.9000052"
                  id="c3-Path-8"
                  stroke="url(#c3-linearGradient-15)"
                  strokeWidth="16.9000009"
                  strokeLinecap="round"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
